import { SvgIcon } from "@mui/material";
import React from "react";

function DashboardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.63659 1.83203H4.89492C2.88742 1.83203 1.83325 2.8862 1.83325 4.88453V6.6262C1.83325 8.62453 2.88742 9.6787 4.88575 9.6787H6.62742C8.62575 9.6787 9.67992 8.62453 9.67992 6.6262V4.88453C9.68909 2.8862 8.63492 1.83203 6.63659 1.83203Z"
        strokeWidth="1.5"
      />
      <path
        d="M17.114 1.83203H15.3723C13.374 1.83203 12.3198 2.8862 12.3198 4.88453V6.6262C12.3198 8.62453 13.374 9.6787 15.3723 9.6787H17.114C19.1123 9.6787 20.1665 8.62453 20.1665 6.6262V4.88453C20.1665 2.8862 19.1123 1.83203 17.114 1.83203Z"
        strokeWidth="1.5"
      />
      <path
        d="M17.114 12.3125H15.3723C13.374 12.3125 12.3198 13.3667 12.3198 15.365V17.1067C12.3198 19.105 13.374 20.1592 15.3723 20.1592H17.114C19.1123 20.1592 20.1665 19.105 20.1665 17.1067V15.365C20.1665 13.3667 19.1123 12.3125 17.114 12.3125Z"
        strokeWidth="1.5"
      />
      <path
        d="M6.63659 12.3125H4.89492C2.88742 12.3125 1.83325 13.3667 1.83325 15.365V17.1067C1.83325 19.1142 2.88742 20.1683 4.88575 20.1683H6.62742C8.62575 20.1683 9.67992 19.1142 9.67992 17.1158V15.3742C9.68909 13.3667 8.63492 12.3125 6.63659 12.3125Z"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
}

export default DashboardIcon;
